<template>
    <div>
        <NuxtPage />
    </div>
</template>

<script setup lang="ts">
    import {use3rdParties, useAsyncData, useHead, useHostSettings, useHTMLAttrsLang, useScripts, useSeoMeta, useTranslation} from '#imports';

    use3rdParties();
    useHTMLAttrsLang();

    const {data, error} = await useAsyncData('host-settings', () => useHostSettings(), {deep: true});
    if (!error.value) {
        const {loadScripts} = useScripts(data.value);
        useHead({script: await loadScripts()});
    }

    const {t} = useTranslation();
    const description = t('seo.malt.meta.description');

    useSeoMeta({
        description,
        robots: 'noindex, nofollow',
    });
</script>
